import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import {Link} from 'react-router';
import ActiveBalloon from 'components/nav/renderers/decorators/ActiveBalloon';
import NavStore from 'stores/NavStore';
import NavActions from 'actions/NavActions';
import {isActive} from 'components/nav/renderers/DefaultNavRenderer';

class InboxNavRendererContainer extends React.Component {
  static getStores() {
    return [NavStore, AuthStore];
  }

  static getPropsFromStores() {
    return {
      inboxMentionsCount: NavStore.getState().inboxMentionsCount,
      sessionUser: AuthStore.getState().user,
    };
  }

  componentDidMount() {
    NavActions.inboxMentionsCount.defer();
  }

  render() {
    return <InboxNavRenderer {...this.props} />;
  }
}

class InboxNavRenderer extends React.Component {
  registerPopoverItem(anchorEl, content) {
    if (this.popoverContainer) {
      this.popoverContainer.registerPopoverItem(anchorEl, content);
    }
  }

  renderTitle(name, size) {
    if (size > 0) {
      return (
        <ActiveBalloon popoverText={`You have ${size} unread mention${size > 1 ? 's' : ''}.`}>
          {name}
        </ActiveBalloon>
      );
    }
    return name;
  }

  render() {
    const {item, location, inboxMentionsCount} = this.props;
    return (
      <span className="navbar-link-wrapper">
        <Link
          to={'/inbox'}
          className={isActive(location, item) ? 'active' : ''}
          activeClassName="active">
          {this.renderTitle(item.name, inboxMentionsCount)}
        </Link>
      </span>
    );
  }
}

export default connectToStores(InboxNavRendererContainer);
